export const SHIPPING_RATES_REQUESTING = 'SHIPPING_RATES_REQUESTING'
export const SHIPPING_RATES_SUCCESS = 'SHIPPING_RATES_SUCCESS'
export const SHIPPING_RATES_ERROR = 'SHIPPING_RATES_ERROR'

export const SHIPPING_RATES_POPULATE_TO = 'SHIPPING_RATES_POPULATE_TO'

export const SORT_SHIPPING_RATES = 'SORT_SHIPPING_RATES'
